import React from 'react';
import Header from '../../component/global/Header';
import TbMenu from '../../component/global/admin/Table/TbMenu';
import SidebarAdmin from '../../component/global/admin/SidebarAdmin';
import HeaderAdmin from '../../component/global/HeaderAdmin';


export default function MenuScreen() {
 return (
  <>
   <HeaderAdmin />
   <div className='page-wrapper'>
    <div className='container-fluid'>
     <TbMenu />
    </div>
   </div>
  </>
 )
}